import { Controller as BaseController } from '@hotwired/stimulus';

export default class Controller extends BaseController {
  static targets = ['card', 'letter', 'icon', 'input'];

  connect() {
    this.initializeSelectedCards();
  }

  initializeSelectedCards() {
    this.cardTargets.forEach((card) => {
      if (card.dataset.selected === 'true') {
        const letter = card.querySelector(
          '[data-socioeconomic-question--controller-target="letter"]',
        );
        const icon = card.querySelector('[data-socioeconomic-question--controller-target="icon"]');
        const padding = card.querySelector(
          '[data-socioeconomic-question--controller-target="padding"]',
        );
        const background = card.querySelector(
          '[data-socioeconomic-question--controller-target="background"]',
        );

        if (background) {
          background.classList.remove('tw-bg-white', 'tw-border-coolGray-300');
          background.classList.add('tw-bg-primary-25', 'tw-border-primary-100');
        }

        if (padding) {
          padding.classList.remove('tw-bg-coolGray-400');
          padding.classList.add('tw-bg-primary-100');
        }

        if (letter) letter.classList.add('tw-hidden');
        if (icon) icon.classList.remove('tw-hidden');
      }
    });
  }

  toggleBackground(event) {
    const selectedCard = event.currentTarget;

    this.cardTargets.forEach((card) => {
      const letter = card.querySelector(
        '[data-socioeconomic-question--controller-target="letter"]',
      );
      const icon = card.querySelector('[data-socioeconomic-question--controller-target="icon"]');
      const input = card.querySelector('[data-socioeconomic-question--controller-target="input"]');
      const padding = card.querySelector(
        '[data-socioeconomic-question--controller-target="padding"]',
      );
      const background = card.querySelector(
        '[data-socioeconomic-question--controller-target="background"]',
      );

      if (card === selectedCard) {
        background.classList.remove('tw-bg-white');
        background.classList.add('tw-bg-primary-25');
        padding.classList.add('tw-bg-primary-100');
        padding.classList.remove('tw-bg-coolGray-400');
        background.classList.remove('tw-border-coolGray-300');
        background.classList.add('tw-border-primary-100');

        card.classList.remove('tw-bg-white', 'tw-border-coolGray-400');

        if (letter) letter.classList.add('tw-hidden');
        if (icon) icon.classList.remove('tw-hidden');
        if (input) input.value = '1';
      } else {
        card.classList.remove('tw-bg-primary-25', 'tw-border-primary-100');
        card.classList.add('tw-bg-white', 'tw-border-coolGray-400');
        padding.classList.remove('tw-bg-primary-100');
        padding.classList.add('tw-bg-coolGray-400');
        background.classList.add('tw-bg-white');
        background.classList.remove('tw-bg-primary-25');
        background.classList.add('tw-border-coolGray-300');
        background.classList.remove('tw-border-primary-100');

        if (letter) letter.classList.remove('tw-hidden');
        if (icon) icon.classList.add('tw-hidden');
        if (input) input.value = '0';
      }
    });

    const input = selectedCard.querySelector(
      '[data-socioeconomic-question--controller-target="input"]',
    );
    if (input) {
      this.autosave(input);
    }
  }

  radioChange(event) {
    const input = event.target;
    this.autosave(input);
  }

  autosave(input) {
    const alternativeIdInput = input.form.querySelector(
      `input[name="${input.name.replace('[selected_value]', '[alternative_id]')}"]`,
    );
    if (!alternativeIdInput) return;

    const alternativeId = alternativeIdInput.value;
    const selectedValue = input.value;
    const studentId = this.element.dataset.studentId;

    const formData = new FormData();
    formData.append('alternative_id', alternativeId);
    formData.append('selected_value', selectedValue);
    formData.append('student', studentId);

    fetch('/socioeconomic/autosave', {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        Accept: 'text/vnd.turbo-stream.html',
      },
    })
      .then((response) => response.text())
      .then((html) => {
        if (html.trim()) {
          Turbo.renderStreamMessage(html);
        }
      });
  }
}
